module.exports = __webpack_public_path__ + "src/assets/textures/leaves/corn_leaf_opacity_map.jpg";